import { render } from "./ClientRevenueChart.vue?vue&type=template&id=a8a01cd4&ts=true"
import script from "./ClientRevenueChart.vue?vue&type=script&lang=ts"
export * from "./ClientRevenueChart.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__